// One notification as the DS NotificationsScreen draws it: a 32px lavender disc with the kind's
// icon, the text (title strong, then the recording or org it is about), the relative lowercase
// time at the right and, while unread, the purple dot. A recording its owner has since trashed
// or deleted gets a one-word badge, since the link no longer opens it. Shared by the bell's popover and the
// notifications page; the row's wrapper (MenuItem or a button) owns the click.
import { Badge, Icon } from "@grackle/ui";
import { formatRelativeTime } from "../library/format";
import type { NotificationOut } from "./api";
import { notificationIcon, notificationText } from "./display";

export function NotificationRow({ notification: n }: { notification: NotificationOut }) {
  const text = notificationText(n);
  return (
    <span className="notif-item__row">
      <span className="notif-item__icon" aria-hidden="true">
        <Icon name={notificationIcon(n.kind)} size={16} />
      </span>
      <span className="notif-item__text">
        <span className="notif-item__title">{text.title}</span>
        <span className="notif-item__body">{text.body}</span>
      </span>
      {n.recording?.state === "trashed" ? (
        <Badge tone="neutral" size="sm" icon="trash">
          Trashed
        </Badge>
      ) : n.recording?.state === "deleted" ? (
        <Badge tone="neutral" size="sm">
          Deleted
        </Badge>
      ) : null}
      <time className="notif-item__time" dateTime={n.created_at}>
        {formatRelativeTime(n.created_at)}
      </time>
      {n.read_at ? null : <span className="notif-item__dot" aria-hidden="true" />}
    </span>
  );
}
